// @ts-nocheck
import * as Types from '../../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import { NamedFragmentDoc } from '../../../../fragments/commonFragments.generated';
import * as ApolloReactCommon from 'src/apolloHooks';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type DevelopmentTemplateItemsModalQueryVariables = Types.Exact<{
  developmentId: Types.Scalars['ID']['input'];
  filter?: Types.InputMaybe<Types.BidContractItemsFilter>;
}>;


export type DevelopmentTemplateItemsModalQuery = { __typename?: 'Query', bidContractItems: Array<{ __typename?: 'BidContractPotentialItem', templateItemIds: Array<string>, needsBid: boolean, item: { __typename?: 'Item', displayName: string, fullCode: string, id: string, name: string, costCode: { __typename?: 'CostCode', displayName: string, id: string, name: string } } }> };

export type DevelopmentTemplateItemsModalMetadataQueryVariables = Types.Exact<{
  developmentId: Types.Scalars['ID']['input'];
}>;


export type DevelopmentTemplateItemsModalMetadataQuery = { __typename?: 'Query', readyPlans: Array<{ __typename?: 'ReadyPlan', id: string, name: string, displayName: string, options: Array<{ __typename?: 'ReadyPlanOption', id: string, displayName: string }> }>, bidContractItems: Array<{ __typename?: 'BidContractPotentialItem', item: { __typename?: 'Item', id: string, costCode: { __typename?: 'CostCode', id: string, displayName: string } } }> };

export type DevelopmentTemplateItemsModalBidContractItemFragment = { __typename?: 'BidContractPotentialItem', templateItemIds: Array<string>, needsBid: boolean, item: { __typename?: 'Item', displayName: string, fullCode: string, id: string, name: string, costCode: { __typename?: 'CostCode', displayName: string, id: string, name: string } } };

export type DevelopmentTemplateItemsModal_ItemFragment = { __typename?: 'Item', displayName: string, fullCode: string, id: string, name: string, costCode: { __typename?: 'CostCode', displayName: string, id: string, name: string } };

export const DevelopmentTemplateItemsModal_ItemFragmentDoc = gql`
    fragment DevelopmentTemplateItemsModal_Item on Item {
  ...Named
  displayName
  fullCode
  costCode {
    ...Named
    displayName
  }
}
    ${NamedFragmentDoc}`;
export const DevelopmentTemplateItemsModalBidContractItemFragmentDoc = gql`
    fragment DevelopmentTemplateItemsModalBidContractItem on BidContractPotentialItem {
  item {
    ...DevelopmentTemplateItemsModal_Item
  }
  templateItemIds
  needsBid
}
    ${DevelopmentTemplateItemsModal_ItemFragmentDoc}`;
export const DevelopmentTemplateItemsModalDocument = gql`
    query DevelopmentTemplateItemsModal($developmentId: ID!, $filter: BidContractItemsFilter) {
  bidContractItems(filter: $filter, developmentId: $developmentId) {
    ...DevelopmentTemplateItemsModalBidContractItem
  }
}
    ${DevelopmentTemplateItemsModalBidContractItemFragmentDoc}`;

/**
 * __useDevelopmentTemplateItemsModalQuery__
 *
 * To run a query within a React component, call `useDevelopmentTemplateItemsModalQuery` and pass it any options that fit your needs.
 * When your component renders, `useDevelopmentTemplateItemsModalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDevelopmentTemplateItemsModalQuery({
 *   variables: {
 *      developmentId: // value for 'developmentId'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useDevelopmentTemplateItemsModalQuery(baseOptions: ApolloReactHooks.QueryHookOptions<DevelopmentTemplateItemsModalQuery, DevelopmentTemplateItemsModalQueryVariables> & ({ variables: DevelopmentTemplateItemsModalQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<DevelopmentTemplateItemsModalQuery, DevelopmentTemplateItemsModalQueryVariables>(DevelopmentTemplateItemsModalDocument, options);
      }
export function useDevelopmentTemplateItemsModalLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<DevelopmentTemplateItemsModalQuery, DevelopmentTemplateItemsModalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<DevelopmentTemplateItemsModalQuery, DevelopmentTemplateItemsModalQueryVariables>(DevelopmentTemplateItemsModalDocument, options);
        }
// @ts-ignore
export function useDevelopmentTemplateItemsModalSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<DevelopmentTemplateItemsModalQuery, DevelopmentTemplateItemsModalQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<DevelopmentTemplateItemsModalQuery, DevelopmentTemplateItemsModalQueryVariables>;
export function useDevelopmentTemplateItemsModalSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<DevelopmentTemplateItemsModalQuery, DevelopmentTemplateItemsModalQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<DevelopmentTemplateItemsModalQuery | undefined, DevelopmentTemplateItemsModalQueryVariables>;
export function useDevelopmentTemplateItemsModalSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<DevelopmentTemplateItemsModalQuery, DevelopmentTemplateItemsModalQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<DevelopmentTemplateItemsModalQuery, DevelopmentTemplateItemsModalQueryVariables>(DevelopmentTemplateItemsModalDocument, options);
        }
export type DevelopmentTemplateItemsModalQueryHookResult = ReturnType<typeof useDevelopmentTemplateItemsModalQuery>;
export type DevelopmentTemplateItemsModalLazyQueryHookResult = ReturnType<typeof useDevelopmentTemplateItemsModalLazyQuery>;
export type DevelopmentTemplateItemsModalSuspenseQueryHookResult = ReturnType<typeof useDevelopmentTemplateItemsModalSuspenseQuery>;
export type DevelopmentTemplateItemsModalQueryResult = ApolloReactCommon.QueryResult<DevelopmentTemplateItemsModalQuery, DevelopmentTemplateItemsModalQueryVariables>;
export const DevelopmentTemplateItemsModalMetadataDocument = gql`
    query DevelopmentTemplateItemsModalMetadata($developmentId: ID!) {
  readyPlans(filter: {development: [$developmentId]}) {
    id
    name
    displayName
    options {
      id
      displayName
    }
  }
  bidContractItems(developmentId: $developmentId) {
    item {
      id
      costCode {
        id
        displayName
      }
    }
  }
}
    `;

/**
 * __useDevelopmentTemplateItemsModalMetadataQuery__
 *
 * To run a query within a React component, call `useDevelopmentTemplateItemsModalMetadataQuery` and pass it any options that fit your needs.
 * When your component renders, `useDevelopmentTemplateItemsModalMetadataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDevelopmentTemplateItemsModalMetadataQuery({
 *   variables: {
 *      developmentId: // value for 'developmentId'
 *   },
 * });
 */
export function useDevelopmentTemplateItemsModalMetadataQuery(baseOptions: ApolloReactHooks.QueryHookOptions<DevelopmentTemplateItemsModalMetadataQuery, DevelopmentTemplateItemsModalMetadataQueryVariables> & ({ variables: DevelopmentTemplateItemsModalMetadataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<DevelopmentTemplateItemsModalMetadataQuery, DevelopmentTemplateItemsModalMetadataQueryVariables>(DevelopmentTemplateItemsModalMetadataDocument, options);
      }
export function useDevelopmentTemplateItemsModalMetadataLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<DevelopmentTemplateItemsModalMetadataQuery, DevelopmentTemplateItemsModalMetadataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<DevelopmentTemplateItemsModalMetadataQuery, DevelopmentTemplateItemsModalMetadataQueryVariables>(DevelopmentTemplateItemsModalMetadataDocument, options);
        }
// @ts-ignore
export function useDevelopmentTemplateItemsModalMetadataSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<DevelopmentTemplateItemsModalMetadataQuery, DevelopmentTemplateItemsModalMetadataQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<DevelopmentTemplateItemsModalMetadataQuery, DevelopmentTemplateItemsModalMetadataQueryVariables>;
export function useDevelopmentTemplateItemsModalMetadataSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<DevelopmentTemplateItemsModalMetadataQuery, DevelopmentTemplateItemsModalMetadataQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<DevelopmentTemplateItemsModalMetadataQuery | undefined, DevelopmentTemplateItemsModalMetadataQueryVariables>;
export function useDevelopmentTemplateItemsModalMetadataSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<DevelopmentTemplateItemsModalMetadataQuery, DevelopmentTemplateItemsModalMetadataQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<DevelopmentTemplateItemsModalMetadataQuery, DevelopmentTemplateItemsModalMetadataQueryVariables>(DevelopmentTemplateItemsModalMetadataDocument, options);
        }
export type DevelopmentTemplateItemsModalMetadataQueryHookResult = ReturnType<typeof useDevelopmentTemplateItemsModalMetadataQuery>;
export type DevelopmentTemplateItemsModalMetadataLazyQueryHookResult = ReturnType<typeof useDevelopmentTemplateItemsModalMetadataLazyQuery>;
export type DevelopmentTemplateItemsModalMetadataSuspenseQueryHookResult = ReturnType<typeof useDevelopmentTemplateItemsModalMetadataSuspenseQuery>;
export type DevelopmentTemplateItemsModalMetadataQueryResult = ApolloReactCommon.QueryResult<DevelopmentTemplateItemsModalMetadataQuery, DevelopmentTemplateItemsModalMetadataQueryVariables>;